import { ChevronDownIcon, ChevronUpIcon } from "@radix-ui/react-icons";
import * as Select from "@radix-ui/react-select";
import { useSignupStore } from "@/reducers";
const employmentStatuses = [
  "Employed",
  "Self-Employed",
  "Retired",
  "Unemployed",
  "Student",
];
export const EmploymentStatusSelector = () => {
  const { employmentStatus } = useSignupStore();
  const setEmploymentStatus = useSignupStore.use.setEmploymentStatus();
  const setOccupation = useSignupStore.use.setOccupation();
  return (
    <Select.Root
      required
      value={employmentStatus}
      onValueChange={(value) => {
        setEmploymentStatus(value);
        if (value === "Employed" || value === "Self-Employed") {
          // clear occupation store
          setOccupation(undefined);
        } else {
          // set occupation store as employment status
          setOccupation(value);
        }
      }}
      data-testid="form-employmentstatusselector"
    >
      <Select.Trigger
        className="text-pebble dark:text-snow py-2 h-full w-full inline-flex items-end leading-none gap-[5px] min-w-[150px] justify-between data-[placeholder]:text-gray-400 dark:data-[placeholder]:text-gray-400 outline-none border-b-rock border-b-2"
        data-testid="form-employmentstatusselector"
      >
        <Select.Value
          placeholder="Select option"
          data-testid="form-employmentstatusselector"
        />
        <Select.Icon
          className="text-gray-400"
          data-testid="form-employmentstatusselector"
        >
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          className="bg-white dark:bg-pebble border border-pebble dark:border-white overflow-hidden"
          data-testid="form-employmentstatusselector"
        >
          <Select.ScrollUpButton
            className="p-2.5"
            data-testid="form-employmentstatusselector"
          >
            <ChevronUpIcon />
          </Select.ScrollUpButton>
          <Select.Viewport data-testid="form-employmentstatusselector">
            {employmentStatuses.map((employmentStatus) => {
              return (
                <Select.Item
                  key={employmentStatus}
                  value={employmentStatus}
                  className="hover:bg-rock min-w-[150px] justify-between p-2 cursor-pointer"
                  data-testid={`employment-status-selector-item-${employmentStatus.toLowerCase()}`}
                >
                  <Select.ItemText
                    data-testid={`employment-status-selector-item-text-${employmentStatus.toLowerCase()}`}
                  >
                    {employmentStatus}
                  </Select.ItemText>
                </Select.Item>
              );
            })}
          </Select.Viewport>
          <Select.ScrollDownButton
            className="p-2.5 text-gray-400"
            data-testid="form-employmentstatusselector"
          >
            <ChevronDownIcon />
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

/* 
Potential improvements:
1. Add appropriate aria-labels for better accessibility
2. Add form validation feedback (visual indicators for required selection)
3. Consider adding descriptions or help text for each employment status
4. Add a loading state for async data operations
5. Improve keyboard navigation and focus management
6. Consider adding confirmation or warning when changing employment status affects other form fields
7. Add transition effects for smoother UX
*/
